const DEFAULT_DEBOUNCE_TIME = 100;

export function debounce<F extends (...args: any[]) => void>(
  func: F,
  delay: number
): F {
  let timeoutId: number | undefined = undefined;

  const debounced = (...args: any[]) => {
    timeoutId !== undefined && clearTimeout(timeoutId);
    timeoutId = self.setTimeout(() => func(...args), delay);
  };

  return debounced as F;
}

// this batch function assumes input parameter
// to be 1 single argument of type T
export default function batchFunction<T>(
  batchHandler: (args: T[]) => void,
  batchTime: number | undefined
): (args: T) => void {
  const argumentBuffer: T[] = [];
  const debounced = debounce(() => {
    batchHandler(argumentBuffer);
    argumentBuffer.length = 0;
  }, batchTime || DEFAULT_DEBOUNCE_TIME);

  return (args: T) => {
    argumentBuffer.push(args);
    debounced();
  };
}
